module.exports = __webpack_public_path__ + "static/img/btn_10.281c3d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/header/btn_10.png
// module id = pmlQ
// module chunks = 4